<div class="mainCompoment">
    <div class="content">
        <div class="left logo-aoe" [routerLink]="['']">
        </div>

        <div class="middle w-100">
            <nav class="nav-wrapper d-flex align-items-center w-100">
                <ul class=" d-flex flex-row justify-content-around align-items-center w-100">
                    <li>
                        <a [routerLink]=" ['']" [routerLinkActive]="'active'">Live</a>
                    </li>
                    <!-- <li>
                        <a [routerLink]="['devis']" [routerLinkActive]="'active'">Devis</a>
                    </li> -->
                    <!-- <li>
                        <a [routerLink]="['accueil']" [routerLinkActive]="'active'">Accueil</a>
                    </li> -->
                    <!-- <li>
                        <a [routerLink]="['contact']" [routerLinkActive]="'active'">Contact</a>
                    </li> -->
                    @if (isConnected) {
                    <li>
                        <a [routerLink]="['admin']" [routerLinkActive]="'active'" class="d-flex flex-row">
                            Admin
                        </a>
                    </li>
                    }
                </ul>
            </nav>

        </div>

        <div class="right d-flex flex-row align-items-center">
            <button matButton="text" (click)="isConnected ? logout() : openLoginDialog()">
                @if (!isConnected) {Espace organisateur} @else {Se déconnecter}
            </button>
        </div>
    </div>
</div>